import { Recipes } from "../components/Recipes"

export const RecipesPage = () => {
    return (
        <div className="pagecontent">
            <h1>Рецепты</h1>
            <Recipes />
        </div>
    )
}